export default __webpack_public_path__ + "static/media/Belt of Fearless Souls.d2c35f33.jpg";